<template>
  <div class="home">
    <img src="../image/home/logo.png" alt="" class="logo" />
    <img src="../image/home/phone.png" alt="" class="phone" />

    <div class="download-app" @click="goApp">
      <img src="../image/home/app.png" alt="" />
      <div class="download-app-text">
        <div class="download-app-text-get">Get it on</div>
        <div class="download-app-text-app">App Store</div>
      </div>
    </div>

    <img src="../image/home/Haba.png" alt="" class="Haba" />

    <img src="../image/home/Gam.png" alt="" class="Gam" />

    <div class="bom">
      <div @click="Terms">Terms of Service</div>
      <div @click="Privacy">Privacy Policy</div>
      <div @click="About">About Us</div>
      <div @click="Contact">Contact Us</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {};
  },
  methods: {
    Terms() {
      this.$router.push({ name: 'terms' });
    },
    Privacy() {
      this.$router.push({ name: 'privacy' });
    },
    About() {
      this.$router.push({ name: 'about' });
    },
    Contact() {
      this.$router.push({ name: 'contact' });
    },
    goApp() {
      window.location.href = 'https://apps.apple.com/us/app/haba/id6741684905';
    },
  },

  mounted() {
    const isMobile = /iPhone|iPad|iPod|Android|Windows Phone/i.test(
      navigator.userAgent
    );
    if (isMobile) {
      //手机逻辑
    } else {
      // PC端逻辑
      this.$router.push({ name: 'home' });
    }
  },
};
</script>

<style scoped lang="scss">
.home {
  width: 100vw;
  height: 100vh;
  background: #ffffff;
  background: url('../image/home/bag.png') no-repeat;
  background-size: cover;
  background-position: 16% 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  position: relative;

  .logo {
    width: 112px;
    height: 46px;
    margin-top: 10%;
  }
  .phone {
    width: 130%;
    height: 60%;
    position: absolute;
    bottom: 0;
  }

  .Haba {
    width: 10rem;
    height: 2.8rem;
    margin-top: 5%;
    margin-bottom: 5%;
  }
  .Gam {
    width: 20rem;
    height: 2rem;
  }
  .bom {
    display: flex;
    position: absolute;
    bottom: 4%;
    left: 50%;
    transform: translateX(-50%);
    color: #16b1b1;
    font-weight: bold;
    font-size: 10px;
    div {
      margin: 0 15px;
      user-select: none;
      white-space: nowrap;
      -webkit-user-select: none; /* 兼容 Chrome 和 Safari */
      -moz-user-select: none; /* 兼容 Firefox */
      -ms-user-select: none; /* 兼容旧版 IE */
    }
  }
  .download-app {
    width: 150px;
    height: 40px;
    margin-top: 6%;
    border-radius: 60px;
    background: #000000;
    margin-right: 17px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding-left: 25px;
    cursor: pointer;
    img {
      width: 25px;
      height: 25px;
      margin-right: 7px;
    }

    .download-app-text {
      color: #ffffff;

      .download-app-text-get {
        font-size: 10px;
      }

      .download-app-text-app {
        font-size: 12px;
      }
    }
  }
}
</style>
